export default "__VITE_ASSET__DWd05Wvy__"